// ** Redux Imports
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
// ** Reducers Imprts
import auth from "./auth";
import navbar from "./navbar";
import layout from "./layout";
import intlRef from "./app";
import chat from "@src/views/apps/chat/store/reducer";
import todo from "@src/views/apps/todo/store/reducer";
import users from "@src/views/apps/user/store/reducer";
import email from "@src/views/apps/email/store/reducer";
import invoice from "@src/views/apps/invoice/store/reducer";
import calendar from "@src/views/apps/calendar/store/reducer";
import ecommerce from "@src/views/apps/ecommerce/store/reducer";
import dataTables from "@src/views/tables/data-tables/store/reducer";
import education from "@src/views/apps/education/store/reducer";
import materials from "@src/views/apps/materials/store/reducer";
import exams from "@src/views/apps/exams/store/reducer";
import contests from "@src/views/apps/contests/store/reducer";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["auth"],
};

const rootReducer = combineReducers({
  auth,
  todo,
  chat,
  email,
  users,
  navbar,
  layout,
  invoice,
  calendar,
  ecommerce,
  dataTables,
  education,
  materials,
  exams,
  contests,
  intlRef,
});

export default persistReducer(persistConfig, rootReducer);
